import React from 'react';
import { Link, useParams, useRouteMatch, useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import './Nav.css'
import { connect } from 'react-redux';

const classNames = require('classnames');

function NavLink(props: { to: string, children: JSX.Element | JSX.Element[] | string, exact?: boolean, except?: (path: string) => boolean }) {
    let match = useRouteMatch({
        path: props.to,
        exact: props.exact
    });
    let location = useLocation();
    const isExcept = match && props.except && props.except(location.pathname);
    return (
        <Link className={classNames("nav-link", match && !isExcept ? "active" : null)} to={props.to}>
            {props.children}
        </Link>
    )
}

function Nav(props: {
    className?: string,
    userName: string
}) {


    let { spec } = useParams<{ spec: string }>();

    return (
        <ul className={classNames("nav nav-pills gsde align-self-center", props.className)}>
           
            {/* 工区管理 */}
            <li className="nav-item ">
                <NavLink to={`/${props.userName}/project/${spec}`}>
                    <FormattedMessage id="project" description="project" defaultMessage="project" />
                </NavLink>
            </li>
            {/* 数据管理 */}
            <li className="nav-item ">
                <NavLink to={`/${props.userName}/data/${spec}`}>
                    <FormattedMessage id="data" description="data" defaultMessage="data" />
                </NavLink>
            </li>
            {/* 专业计算 */}
            <li className="nav-item ">
                <NavLink to={`/${props.userName}/progress/${spec}`} except={path => /rtcompute/.test(path)}>
                    <FormattedMessage id="progress" description="progress" defaultMessage="progress" />
                </NavLink>
            </li>
            {/* 采集设计 */}
            <li className="nav-item ">
                <NavLink to={`/${props.userName}/design1/${spec}`}>
                    <FormattedMessage id="design" description="design" defaultMessage="design" />
                </NavLink>
            </li>
            {/* 实时监控 */}
            {/* <li className="nav-item ">
                <NavLink to={`/${props.userName}/monitor/${spec}`}>
                    <FormattedMessage id="monitor" description="monitor" defaultMessage="monitor" />
                </NavLink>
            </li> */}
            <li className="nav-item ">
                <NavLink to={`/${props.userName}/rtprogress`}>
                    实时计算
                </NavLink>
            </li>

            {/* <li className="nav-item ">
                <NavLink to={`/${props.userName}/achievement/${spec}`}>
                    <FormattedMessage id="achievement" description="achievement" defaultMessage="achievement" />
                </NavLink>
            </li> */}



            {/* <li className="nav-item ">
                <NavLink to={`/${props.userName}/design/${spec}`}>
                    采集设计1
                </NavLink>
                
            </li> */}
             {/* 用户信息 */}
             {
                props.userName.indexOf(':') != -1 ? '' : <li className="nav-item ">
                    <NavLink to={`/${props.userName}/gis/${spec}`}>
                        {/* <FormattedMessage id="gis" description="gis" defaultMessage="gis" /> */}
                        用户信息
                    </NavLink>
                </li>
            }

            {
                props.userName.indexOf(':') != -1 ? '' : <li className="nav-item ">
                    <NavLink to={`/${props.userName}/useCenter`}>
                        <FormattedMessage id="userCenter" description="userCenter" defaultMessage="userCenter" />
                    </NavLink>
                </li>
            }
            {/* 文件下载 */}
            <li className="nav-item ">
                <NavLink to={`/${props.userName}/download`}>
                    <FormattedMessage id="filedownload" description="Download" defaultMessage="Download" />
                </NavLink>
            </li>
            {/* 用户中心 */}


        </ul>
    )
}

const mapStateToProps = (state: {
    user: { userName: string }
}) => {
    return {
        userName: state.user.userName,
    };
};



export default connect(
    mapStateToProps
)(Nav);
